import { Button, Popconfirm, Space } from 'antd';
import type { AiArtifactType } from '../../../types/ai-analysis.types';
export default function AiArtifactDecisionBar({
  approved,
  stale,
  artifactType,
  onApprove,
  onReject,
  onApply,
}: {
  approved: boolean;
  stale?: boolean;
  artifactType: AiArtifactType;
  onApprove: () => void;
  onReject: () => void;
  onApply: (confirmStale: boolean) => void;
}) {
  const canApply = artifactType !== 'ASSOCIATIVE_IMAGE';
  return (
    <Space wrap>
      <Button type="primary" onClick={onApprove}>
        Aprovar
      </Button>
      <Button danger onClick={onReject}>
        Rejeitar
      </Button>
      {canApply &&
        (stale ? (
          <Popconfirm
            title="Este artefato foi gerado sobre uma versão anterior dos resultados. Aplicar mesmo assim?"
            onConfirm={() => onApply(true)}
          >
            <Button disabled={!approved}>Aplicar versão desatualizada</Button>
          </Popconfirm>
        ) : (
          <Button disabled={!approved} onClick={() => onApply(false)}>
            Aplicar em Análise Complementar
          </Button>
        ))}
    </Space>
  );
}
